import { useQuery } from '@hooks/reactQuery';

import { getValuesForCreate } from '@api/schemaConfig';

import { optionsFormattedWithArray } from '@utils/formatter';

import { IValuesForCreateUrl } from '@interfaces/cmModule/schemaConfig';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { VALUES_FOR_CREATE_SCHEMA } from '@constants/queryKeys';

type TValuesForCreate = Record<keyof IValuesForCreateUrl, TSelectOption<string>[]>;

interface IValuesForCreateReturnType {
	valuesForCreate: TValuesForCreate;
	isLoadingValuesForCreate: boolean;
}

const initialValuesObject: TValuesForCreate = {
	buildVersions: [],
	componentTypes: [],
	componentVersions: [],
	names: [],
	nfTypes: [],
	nsIds: [],
	nsVersions: [],
	productNames: [],
	vduIds: [],
};

const useQueryValuesForCreate = (): IValuesForCreateReturnType => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [VALUES_FOR_CREATE_SCHEMA],
		queryFn: getValuesForCreate,
		select: (data) => {
			return Object.entries(data)
				.reduce<TValuesForCreate>((acc, [key, value]) => {
					acc[key as keyof IValuesForCreateUrl] = optionsFormattedWithArray(value);

					return acc;
				}, initialValuesObject);

		},
		...refetchOptions,
	});

	return {
		valuesForCreate: data || initialValuesObject,
		isLoadingValuesForCreate: isLoading || isFetching,
	};
};

export default useQueryValuesForCreate;
